import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters76mmClearviewMidRailRevealFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters76"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={405.67}
          y1={486.95}
          x2={405.67}
          y2={482.79}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={405.67}
          y1={511.62}
          x2={405.67}
          y2={507.47}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={405.67}
          y1={536.3}
          x2={405.67}
          y2={532.15}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={405.67}
          y1={560.98}
          x2={405.67}
          y2={556.82}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={405.67}
          y1={585.65}
          x2={405.67}
          y2={581.5}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={405.67}
          y1={610.33}
          x2={405.67}
          y2={606.18}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={405.67}
          y1={666.82}
          x2={405.67}
          y2={662.67}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={405.67}
          y1={691.5}
          x2={405.67}
          y2={687.35}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={405.67}
          y1={716.18}
          x2={405.67}
          y2={712.02}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={405.67}
          y1={740.85}
          x2={405.67}
          y2={736.7}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={405.67}
          y1={765.53}
          x2={405.67}
          y2={761.38}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={405.67}
          y1={790.21}
          x2={405.67}
          y2={786.05}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          x1={40.93}
          y1={496.62}
          x2={40.93}
          y2={471.71}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7082.88}
          y1={496.62}
          x2={7082.88}
          y2={471.71}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          x1={40.93}
          y1={521.71}
          x2={40.93}
          y2={496.8}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7082.88}
          y1={521.71}
          x2={7082.88}
          y2={496.8}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          x1={40.93}
          y1={546.98}
          x2={40.93}
          y2={522.06}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7082.88}
          y1={546.98}
          x2={7082.88}
          y2={522.06}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          x1={40.93}
          y1={572.25}
          x2={40.93}
          y2={547.34}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7082.88}
          y1={572.25}
          x2={7082.88}
          y2={547.34}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          x1={40.93}
          y1={597.5}
          x2={40.93}
          y2={572.59}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7082.88}
          y1={597.5}
          x2={7082.88}
          y2={572.59}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          x1={40.93}
          y1={622.78}
          x2={40.93}
          y2={597.87}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7082.88}
          y1={622.78}
          x2={7082.88}
          y2={597.87}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          x1={40.93}
          y1={675.13}
          x2={40.93}
          y2={650.22}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={7082.88}
          y1={675.13}
          x2={7082.88}
          y2={650.22}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          x1={40.93}
          y1={700.41}
          x2={40.93}
          y2={675.5}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={7082.88}
          y1={700.41}
          x2={7082.88}
          y2={675.5}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          x1={40.93}
          y1={725.69}
          x2={40.93}
          y2={700.79}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={7082.88}
          y1={725.69}
          x2={7082.88}
          y2={700.79}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-31"
          x1={40.93}
          y1={750.94}
          x2={40.93}
          y2={726.02}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-32"
          x1={7082.88}
          y1={750.94}
          x2={7082.88}
          y2={726.02}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-33"
          x1={40.93}
          y1={776.21}
          x2={40.93}
          y2={751.3}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-34"
          x1={7082.88}
          y1={776.21}
          x2={7082.88}
          y2={751.3}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-35"
          x1={40.93}
          y1={801.48}
          x2={40.93}
          y2={776.58}
          xlinkHref="#prefix__linear-gradient-13"
        />
        <linearGradient
          id="prefix__linear-gradient-36"
          x1={7082.88}
          y1={801.48}
          x2={7082.88}
          y2={776.58}
          gradientTransform="matrix(-1 0 0 1 7339.09 -432)"
          xlinkHref="#prefix__linear-gradient-13"
        />
        <style>
          {
            '.prefix__cls-1{fill:url(#shutters76)}.prefix__cls-2,.prefix__cls-3,.prefix__cls-5,.prefix__cls-8{fill:none;stroke:#4d4d4d;stroke-miterlimit:10}.prefix__cls-2{stroke-width:.95px}.prefix__cls-2,.prefix__cls-3,.prefix__cls-8{opacity:.15;isolation:isolate}.prefix__cls-3{stroke-width:.94px}.prefix__cls-5{stroke-width:.81px}.prefix__cls-6{opacity:.2}.prefix__cls-7{fill:#333}.prefix__cls-8{stroke-width:.83px}.prefix__cls-48{fill:gray;opacity:.2}'
          }
        </style>
      </defs>
      <path
        className="prefix__cls-1"
        d="M514.36 12.3H12.1v384.4h529.79V12.3zm0 357.33H297v-11.47h217.36zm0-15.6H297v-20.49h217.36zm0-24.62H297v-20.49h217.36zm0-24.72H297V284.2h217.36zm0-24.63H297v-20.58h217.36zm0-24.71H297v-20.49h217.36zm0-24.72H297V218h217.36zm0-39.66H297v-12.6h217.36zm0-16.83H297v-20.49h217.36zm0-24.62H297V129h217.36zm0-24.72H297v-20.49h217.36zm0-24.62H297V79.59h217.36zm0-24.72H297V55h217.36zm0-24.62H297V39.37h217.36z"
      />
      <path className="prefix__cls-2" d="M12.1 12.3h27.53v384.4H12.1z" />
      <path
        className="prefix__cls-3"
        d="M39.61 12.28h217.38v27.07H39.61zM39.63 190.97h217.38v27.07H39.63zM296.98 190.96h217.38v27.07H296.98zM39.66 369.66h217.38v27.07H39.66zM296.96 12.28h217.38v27.07H296.96zM297.01 369.65h217.38v27.07H297.01z"
      />
      <path className="prefix__cls-2" d="M514.36 12.3h27.53v384.4h-27.53z" />
      <g opacity={0.15}>
        <path
          className="prefix__cls-5"
          d="M257.02 12.3H277v384.4h-19.98zM277 12.3h19.98v384.4H277z"
        />
      </g>
      <g className="prefix__cls-6">
        <path
          className="prefix__cls-7"
          d="M12.1 71.89h2.49v35.81H12.1zM12.1 301.3h2.49v35.81H12.1z"
        />
      </g>
      <g className="prefix__cls-6">
        <path
          className="prefix__cls-7"
          d="M539.41 71.89h2.49v35.81h-2.49zM539.41 301.3h2.49v35.81h-2.49z"
        />
      </g>
      <path className="prefix__cls-8" d="M39.64 39.37h217.38v25.28H39.64z" />
      <g opacity={0.54}>
        <path
          fill="url(#prefix__linear-gradient)"
          d="M296.98 50.84h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-2)"
          d="M296.98 75.46h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-3)"
          d="M296.98 100.18h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-4)"
          d="M296.98 124.8h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-5)"
          d="M296.98 149.52h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-6)"
          d="M296.98 174.14h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-7)"
          d="M296.98 230.63h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-8)"
          d="M296.98 255.35h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-9)"
          d="M296.98 280.06h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-10)"
          d="M296.98 304.69h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-11)"
          d="M296.98 329.41h217.38v4.14H296.98z"
        />
        <path
          fill="url(#prefix__linear-gradient-12)"
          d="M296.98 354.03h217.38v4.14H296.98z"
        />
      </g>
      <path
        className="prefix__cls-8"
        d="M39.64 64.65h217.38v25.28H39.64zM39.64 89.93h217.38v25.28H39.64z"
      />
      <path
        className="prefix__cls-8"
        d="M39.64 115.12h217.38v25.28H39.64zM39.64 140.4h217.38v25.28H39.64zM39.64 165.68h217.38v25.28H39.64zM39.64 218.03h217.38v25.28H39.64zM39.64 243.32h217.38v25.28H39.64zM39.64 268.6h217.38v25.28H39.64zM39.64 293.88h217.38v25.28H39.64z"
      />
      <path
        className="prefix__cls-8"
        d="M39.64 319.07h217.38v25.28H39.64zM39.64 344.35h217.38v25.28H39.64z"
      />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M41.74 39.74h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M255.4 39.74h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M41.74 64.84h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M255.4 64.84h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M41.74 90.03h-1.63v25l1.63-25z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M255.4 90.03h1.62v25l-1.62-25z"
      />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M41.74 115.31h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M255.4 115.31h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M41.74 140.59h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M255.4 140.59h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M41.74 165.87h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M255.4 165.87h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M41.74 218.22h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M255.4 218.22h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M41.74 243.5h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M255.4 243.5h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M41.74 268.79h-1.63v24.9l1.63-24.9z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M255.4 268.79h1.62v24.9l-1.62-24.9z"
      />
      <path
        fill="url(#prefix__linear-gradient-31)"
        d="M41.74 293.97h-1.63v25l1.63-25z"
      />
      <path
        fill="url(#prefix__linear-gradient-32)"
        d="M255.4 293.97h1.62v25l-1.62-25z"
      />
      <path
        fill="url(#prefix__linear-gradient-33)"
        d="M41.74 319.25h-1.63v24.91l1.63-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-34)"
        d="M255.4 319.25h1.62v24.91l-1.62-24.91z"
      />
      <path
        fill="url(#prefix__linear-gradient-35)"
        d="M41.74 344.54h-1.63v24.9l1.63-24.9z"
      />
      <path
        fill="url(#prefix__linear-gradient-36)"
        d="M255.4 344.54h1.62v24.9l-1.62-24.9z"
      />
      <path
        style={{
          isolation: 'isolate',
        }}
        opacity={0.2}
        fill="none"
        stroke="#4d4d4d"
        strokeMiterlimit={10}
        d="M0 0h555.2v410H0z"
      />
      <path
        className="prefix__cls-1"
        d="M0 0v410h555.2V0zm542 396.75H13.25V13.25H542z"
      />
      <path
        d="M554.2 1v408H1V1h553.2M12.25 397.75H543V12.25H12.25v385.5M555.2 0H0v410h555.2zM13.25 396.75V13.25H542v383.5z"
        fill="#4d4d4d"
      />
      <path
        className="prefix__cls-48"
        d="M550.84 4.38l3.37-3.39v407.99l-3.37-3.36V4.38zM4.38 4.38L1.01.99v407.99l3.37-3.36V4.38zM4.37 405.64l-3.38 3.37h553.22l-3.36-3.37H4.37z"
      />
      <path
        className="prefix__cls-48"
        d="M4.37 4.36L.99.99h553.22l-3.36 3.37H4.37z"
      />
    </svg>
  );
};
